<template>
  <div :class="$style.header">
    <div>
      <h1>
        {{ deviceData.supplier.name }} {{ deviceData.part_number }}
      </h1>
    </div>
    <div :class="$style.info">
      <div :class="$style.infoBlock">
        <span :class="$style.infoBlockValue">
          <BaseLabel
            :class="$style.infoBlockLabel"
            :color="getDeviceTypeLabelColor(deviceData.type)"
          >
            {{ deviceData.type }}
          </BaseLabel>
          <BaseLabel
            :class="$style.infoBlockLabel"
            color="aqua"
          >
            {{ deviceData.supplier.region }}
            <img
              :src="`/images/icons/flags/${deviceData.supplier.country.toLowerCase()}.png`"
              :alt="deviceData.supplier.country"
              :class="$style.flag"
            >
          </BaseLabel>
        </span>
      </div>

      <div :class="$style.infoBlock">
        <span :class="$style.infoBlockHeading">
          <TablePriceSvg />
        </span>
        <span :class="$style.infoBlockValue">
          {{ deviceData.aftermarket_price }}
        </span>
      </div>

      <div :class="$style.infoBlock">
        <span :class="$style.infoBlockHeading">
          <TablePartsSvg />
          <span :class="$style.infoBlockTitle">
            Parts Per Car
          </span>
        </span>
        <span :class="$style.infoBlockValue">
          {{ deviceData.parts_per_car }}
        </span>
      </div>
      <div :class="$style.infoBlock">
        <span :class="$style.infoBlockHeading">
          <TableDateStartSvg />
        </span>
        <span :class="$style.infoBlockValue">
          SOP {{ format(new Date(deviceData.min_sop), 'MMMM y') }}
          –
          EOP {{ format(new Date(deviceData.max_eop), 'MMMM y') }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import BaseLabel from '@/components/base/Label';
import TableDateStartSvg from '@/assets/images/icons/table-date-start.svg?inline';
import TablePriceSvg from '@/assets/images/icons/table-price.svg?inline';
import TablePartsSvg from '@/assets/images/icons/table-parts.svg?inline';
import getDeviceTypeLabelColor from '@/utils/getDeviceTypeLabelColor';

export default {
  components: {
    BaseLabel,
    TableDateStartSvg,
    TablePriceSvg,
    TablePartsSvg,
  },
  props: {
    deviceData: {
      type: Object,
      default: null,
    },
  },
  methods: {
    format,
    getDeviceTypeLabelColor,
    formatUnits(value, units) {
      return value ? `${value}${units}` : null;
    },
    formatDimension(value) {
      return this.formatUnits(value, 'mm');
    },
    formatWeight(value) {
      return this.formatUnits(value, 'g');
    },
  },
};
</script>

<style lang="scss" module>
.header {
  padding-left: 15px;

  h1 {
    margin: 0;
    font-size: 45px;
    color: $title;
  }
}

.info {
  display: flex;
  flex-wrap: wrap;
  margin-top: 5px;
  margin-left: -18px;
}

.infoBlockGroup {
  display: inline-flex;
  align-items: center;
  margin-top: 10px;
  margin-left: 15px;
  white-space: nowrap;

  .infoBlock {
    margin-top: 0;
    margin-left: 10px;
  }
}

.infoBlock {
  display: inline-flex;
  align-items: center;
  margin-top: 10px;
  margin-left: 18px;
}

.infoBlockHeading {
  display: inline-flex;
  align-items: center;
  margin-right: 5px;

  svg {
    margin-top: -3px;

    + .infoBlockTitle {
      margin-left: 5px;
    }
  }
}

.infoBlockTitle {
  display: inline-block;
  font-size: 13px;
  font-weight: 500;
}

.infoBlockValue {
  display: inline-flex;
  font-size: 13px;
  color: $text;
  letter-spacing: -0.01px;
}

.infoBlockLabel {

  &:not(:first-child) {
    margin-left: 5px;
  }
}

.flag {
  margin-bottom: -1px;
  margin-left: 3px;
}
</style>
